module.exports = __webpack_public_path__ + "static/media/twittercolored.e6b87971.svg";


//////////////////
// WEBPACK FOOTER
// ./src/blocks/socialButtons/static/img/social/twittercolored.svg
// module id = 2071
// module chunks = 118